import useSWR from 'swr'
import API from '../../../utils/api'
import { getPersistData } from '../../hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/dashboard/report-templates'

let swrData: any = getPersistData(KEY)

type TemplateScope = 'daily' | 'monthly' | 'both'
type TemplateOptions = {
	includeInactive?: boolean
	keyword?: string
}

export function useStudyReportTemplates(scope?: TemplateScope, options: TemplateOptions = {}) {
	const { data: token } = useToken()

	const queryParams = new URLSearchParams()
	if (scope) queryParams.append('scope', scope)

	if (options.keyword) queryParams.append('keyword', options.keyword)

	// SWR key must reflect includeInactive so it refetches when toggled
	const baseQueryString = queryParams.toString()
	const fullKey = `${KEY}?${baseQueryString}${options.includeInactive ? '&includeInactive=true' : '&isActive=true'}`

	const { data, mutate } = useSWR<any>(
		fullKey,
		async () => {
			if (options.includeInactive) {
				const activeQuery = `${KEY}?${baseQueryString}${baseQueryString ? '&' : ''}isActive=true`
				const inactiveQuery = `${KEY}?${baseQueryString}${baseQueryString ? '&' : ''}isActive=false`

				const [activeRes, inactiveRes] = await Promise.all([
					API.get(activeQuery, token + '', {}),
					API.get(inactiveQuery, token + '', {}),
				])

				const activeList = activeRes.result?.result?.list || []
				const inactiveList = inactiveRes.result?.result?.list || []
				const combined = [...activeList, ...inactiveList]

				// Deduplicate by id
				const map = new Map<number, any>()
				combined.forEach((t: any) => {
					if (t?.id != null) map.set(t.id, t)
				})

				swrData = Array.from(map.values())
			} else {
				const activeOnlyQuery = `${KEY}?${baseQueryString}${baseQueryString ? '&' : ''}isActive=true`
				const response = await API.get(activeOnlyQuery, token + '', {})
				swrData = response.result?.result?.list || []
			}

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		templates: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}

